export default __webpack_public_path__ + "navigation-examples-electronic-horizon-thumbnail-960-8e4a28804e57fbe33eec68431e4300e9.webp";